export enum KAMPFKUNST_PRINZIPIEN_ID {
  Achtsamkeit = 'achtsamkeit',
  ArmeWieSeile = 'arme-wie-seile',
  BalanceEntspannung = 'balance-entspannung',
  Genuss = 'genuss',
  Gewicht = 'gewicht',
  Kontakt = 'kontakt',
  Kontinuitaet = 'kontinuitaet',
  Kopieren = 'kopieren',
  NichtDruecken = 'nicht-druecken',
  SchlaegeLadenAuf = 'schlaege-laden-auf',
  Stuetze = 'stuetze',
  YinYang = 'yin-yang',
}
